import type { DiagnosticEventSender } from './types';

export function initNavigationTracker(send: DiagnosticEventSender): () => void {
  let lastUrl = location.href;

  const logNav = () => {
    const currentUrl = location.href;
    if (currentUrl !== lastUrl) {
      send({ t: 'nav', from: lastUrl, to: currentUrl });
      lastUrl = currentUrl;
    }
  };

  const origPush = history.pushState.bind(history);
  const origReplace = history.replaceState.bind(history);

  history.pushState = (...args: Parameters<typeof history.pushState>) => {
    origPush(...args);
    logNav();
  };

  history.replaceState = (...args: Parameters<typeof history.replaceState>) => {
    origReplace(...args);
    logNav();
  };

  window.addEventListener('popstate', logNav);

  return () => {
    history.pushState = origPush;
    history.replaceState = origReplace;
    window.removeEventListener('popstate', logNav);
  };
}
